import React, { createContext, useContext, ReactNode } from 'react';

export interface StaticCartItem {
  id: string;
  title: string;
  description: string;
  originalPrice: string;
  finalPrice: string;
  imageUrl: string;
  isBonus: boolean;
}

interface StaticCartContextType {
  items: StaticCartItem[];
  subtotal: number;
  discount: number;
  total: number;
  bonusCount: number;
  originalTotal: number;
}

const StaticCartContext = createContext<StaticCartContextType | undefined>(undefined);

const STATIC_CART_ITEMS: StaticCartItem[] = [
  {
    id: '0ea46274-5f14-4cb9-afd6-54a99d42fdc0',
    title: 'Mapa Numerológico Pessoal',
    description: 'Descubra seus números pessoais e seu potencial oculto através da Numerologia Cabalística.',
    originalPrice: 'R$ 197,00',
    finalPrice: 'R$ 197,00',
    imageUrl: 'https://cadwnyiuwinrdodagjll.supabase.co/storage/v1/object/public/produto-imagens/1752727988805_p7yi8et5mzr.png',
    isBonus: false
  },
  {
    id: 'c5d8fa96-3468-4474-941c-db68de92b120',
    title: 'Mapa de Vocações Profissionais',
    description: 'Descubra suas verdadeiras aptidões e talentos com base na Numerologia Cabalística.',
    originalPrice: 'R$ 93,00',
    finalPrice: 'GRÁTIS',
    imageUrl: 'https://cadwnyiuwinrdodagjll.supabase.co/storage/v1/object/public/produto-imagens/1752729313612_dbp0bgbbasd.png',
    isBonus: true
  },
  {
    id: 'feef5685-16bf-4440-9925-2fb823f1d9a0',
    title: 'Guia de Ativação Diária (Espiritual)',
    description: 'Ative sua energia espiritual todos os dias com práticas personalizadas baseadas em seus números.',
    originalPrice: 'R$ 84,00',
    finalPrice: 'GRÁTIS',
    imageUrl: 'https://cadwnyiuwinrdodagjll.supabase.co/storage/v1/object/public/produto-imagens/1753280334120_qe3yi1vfsh.png',
    isBonus: true
  },
  {
    id: '331e9d14-0293-49bd-a8eb-9bfd0ff68bfb',
    title: 'Estratégias de Abundância',
    description: 'Aprenda a atrair prosperidade usando os segredos da numerologia e manifestação.',
    originalPrice: 'R$ 129,00',
    finalPrice: 'GRÁTIS',
    imageUrl: 'https://cadwnyiuwinrdodagjll.supabase.co/storage/v1/object/public/produto-imagens/1752729541697_6lik3rjvez6.png',
    isBonus: true
  }
];

export function StaticCartProvider({ children }: { children: ReactNode }) {
  const items = STATIC_CART_ITEMS;
  const originalTotal = 197 + 93 + 84 + 129; // R$ 503,00
  const subtotal = 197; // Apenas o produto pago
  const discount = 306; // Total dos bônus gratuitos
  const total = subtotal;
  const bonusCount = 3;

  return (
    <StaticCartContext.Provider value={{
      items,
      subtotal,
      discount,
      total,
      bonusCount,
      originalTotal
    }}>
      {children}
    </StaticCartContext.Provider>
  );
}

export function useStaticCart() {
  const context = useContext(StaticCartContext);
  if (context === undefined) {
    throw new Error('useStaticCart must be used within a StaticCartProvider');
  }
  return context;
}